import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CurrencyAndLanguageComponent } from './currency-and-language.component';
import { RouterModule } from '@angular/router';
import { VgOffCanvasModule } from '../vg-off-canvas/vg-off-canvas.module';
import { VlButtonModule, VlIconModule, VlListModule } from 'vl-tailwind-layout';

@NgModule({
  declarations: [CurrencyAndLanguageComponent],
  exports: [CurrencyAndLanguageComponent],
  imports: [
    CommonModule,
    RouterModule,
    VlButtonModule,
    VgOffCanvasModule,
    VlListModule,
    VlIconModule
  ]
})
export class CurrencyAndLanguageModule { }